import React, { Component } from 'react';
import { safeParse } from '../utils';
const Parser = safeParse;

// SVG иконки вынесены за пределы класса
const SVGIcons = {
  package: (
    <svg className='flex-none' width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M2.25781 8.41504V11.7825C2.25781 15.15 3.60781 16.5 6.97531 16.5H11.0178C14.3853 16.5 15.7353 15.15 15.7353 11.7825V8.41504" stroke="#032432" strokeWidth="1.125" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M9.00036 9C10.3729 9 11.3854 7.8825 11.2504 6.51L10.7554 1.5H7.25286L6.75036 6.51C6.61536 7.8825 7.62786 9 9.00036 9Z" stroke="#032432" strokeWidth="1.125" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M13.7341 9C15.2491 9 16.3591 7.77 16.2091 6.2625L15.9991 4.2C15.7291 2.25 14.9791 1.5 13.0141 1.5H10.7266L11.2516 6.7575C11.3791 7.995 12.4966 9 13.7341 9Z" stroke="#032432" strokeWidth="1.125" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M4.23077 9C5.46827 9 6.58577 7.995 6.70577 6.7575L6.87077 5.1L7.23077 1.5H4.94327C2.97827 1.5 2.22827 2.25 1.95827 4.2L1.75577 6.2625C1.60577 7.77 2.71577 9 4.23077 9Z" stroke="#032432" strokeWidth="1.125" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M9 12.75C7.7475 12.75 7.125 13.3725 7.125 14.625V16.5H10.875V14.625C10.875 13.3725 10.2525 12.75 9 12.75Z" stroke="#032432" strokeWidth="1.125" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  
  company: (
    <svg className='flex-none' width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9.75 16.5H3.75C2.25 16.5 1.5 15.75 1.5 14.25V8.25C1.5 6.75 2.25 6 3.75 6H7.5V14.25C7.5 15.75 8.25 16.5 9.75 16.5Z" stroke="#009EE3" strokeWidth="1.125" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M7.58249 3C7.52249 3.225 7.5 3.4725 7.5 3.75V6H3.75V4.5C3.75 3.675 4.425 3 5.25 3H7.58249Z" stroke="#009EE3" strokeWidth="1.125" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M10.5 6V9.75" stroke="#009EE3" strokeWidth="1.125" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M13.5 6V9.75" stroke="#009EE3" strokeWidth="1.125" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M12.75 12.75H11.25C10.8375 12.75 10.5 13.0875 10.5 13.5V16.5H13.5V13.5C13.5 13.0875 13.1625 12.75 12.75 12.75Z" stroke="#009EE3" strokeWidth="1.125" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M4.5 9.75V12.75" stroke="#009EE3" strokeWidth="1.125" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M7.5 14.25V3.75C7.5 2.25 8.25 1.5 9.75 1.5H14.25C15.75 1.5 16.5 2.25 16.5 3.75V14.25C16.5 15.75 15.75 16.5 14.25 16.5H9.75C8.25 16.5 7.5 15.75 7.5 14.25Z" stroke="#009EE3" strokeWidth="1.125" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  
  location: (
    <svg className='flex-none' width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M16.5 6.75013V11.2501C16.5 13.1251 16.125 14.4376 15.285 15.2851L10.5 10.5001L16.2975 4.70264C16.4325 5.29514 16.5 5.97013 16.5 6.75013Z" stroke="#009EE3" strokeWidth="1.125" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M16.2975 4.7025L4.70249 16.2975C2.44499 15.78 1.5 14.22 1.5 11.25V6.75C1.5 3 3 1.5 6.75 1.5H11.25C14.22 1.5 15.78 2.445 16.2975 4.7025Z" stroke="#009EE3" strokeWidth="1.125" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M15.2856 15.285C14.4381 16.125 13.1256 16.5 11.2506 16.5H6.75063C5.97063 16.5 5.29563 16.4325 4.70312 16.2975L10.5006 10.5L15.2856 15.285Z" stroke="#009EE3" strokeWidth="1.125" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M4.67898 5.98504C5.18898 3.78754 8.48898 3.78754 8.99898 5.98504C9.29148 7.27504 8.48147 8.37004 7.76897 9.04504C7.25147 9.54004 6.43399 9.54004 5.90899 9.04504C5.19649 8.37004 4.37898 7.27504 4.67898 5.98504Z" stroke="#009EE3" strokeWidth="1.125"/>
      <path d="M6.8201 6.52539H6.82684" stroke="#009EE3" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  
  phone: (
    <svg className='flex-none' width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M16.4775 13.7475C16.4775 14.0175 16.4175 14.295 16.29 14.565C16.1625 14.835 15.9975 15.09 15.78 15.33C15.4125 15.735 15.0075 16.0275 14.55 16.215C14.1 16.4025 13.6125 16.5 13.0875 16.5C12.3225 16.5 11.505 16.32 10.6425 15.9525C9.78 15.585 8.9175 15.09 8.0625 14.4675C7.2 13.8375 6.3825 13.14 5.6025 12.3675C4.83 11.5875 4.1325 10.77 3.51 9.915C2.895 9.06 2.4 8.205 2.04 7.3575C1.68 6.5025 1.5 5.685 1.5 4.905C1.5 4.395 1.59 3.9075 1.77 3.4575C1.95 3 2.235 2.58 2.6325 2.205C3.1125 1.7325 3.6375 1.5 4.1925 1.5C4.4025 1.5 4.6125 1.545 4.8 1.635C4.995 1.725 5.1675 1.86 5.3025 2.055L7.0425 4.5075C7.1775 4.695 7.275 4.8675 7.3425 5.0325C7.41 5.19 7.4475 5.3475 7.4475 5.49C7.4475 5.67 7.395 5.85 7.29 6.0225C7.1925 6.195 7.05 6.375 6.87 6.555L6.3 7.1475C6.2175 7.23 6.18 7.3275 6.18 7.4475C6.18 7.5075 6.1875 7.56 6.2025 7.62C6.225 7.68 6.2475 7.725 6.2625 7.77C6.3975 8.0175 6.63 8.34 6.96 8.73C7.2975 9.12 7.6575 9.5175 8.0475 9.915C8.4525 10.3125 8.8425 10.68 9.24 11.0175C9.63 11.3475 9.9525 11.5725 10.2075 11.7075C10.245 11.7225 10.29 11.745 10.3425 11.7675C10.4025 11.79 10.4625 11.7975 10.53 11.7975C10.6575 11.7975 10.755 11.7525 10.8375 11.67L11.4075 11.1075C11.595 10.92 11.775 10.7775 11.9475 10.6875C12.12 10.5825 12.2925 10.53 12.48 10.53C12.6225 10.53 12.7725 10.56 12.9375 10.6275C13.1025 10.695 13.275 10.7925 13.4625 10.92L15.945 12.6825C16.14 12.8175 16.275 12.975 16.3575 13.1625C16.4325 13.35 16.4775 13.5375 16.4775 13.7475Z" stroke="#009EE3" strokeWidth="1.125" strokeMiterlimit="10"/>
      <path d="M13.875 6.75C13.875 6.3 13.5225 5.61 12.9975 5.0475C12.5175 4.53 11.88 4.125 11.25 4.125" stroke="#009EE3" strokeWidth="1.125" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M16.5 6.75C16.5 3.8475 14.1525 1.5 11.25 1.5" stroke="#009EE3" strokeWidth="1.125" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  
  phoneWhite: (
    <svg className='flex-none' width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M16.4775 13.7475C16.4775 14.0175 16.4175 14.295 16.29 14.565C16.1625 14.835 15.9975 15.09 15.78 15.33C15.4125 15.735 15.0075 16.0275 14.55 16.215C14.1 16.4025 13.6125 16.5 13.0875 16.5C12.3225 16.5 11.505 16.32 10.6425 15.9525C9.78 15.585 8.9175 15.09 8.0625 14.4675C7.2 13.8375 6.3825 13.14 5.6025 12.3675C4.83 11.5875 4.1325 10.77 3.51 9.915C2.895 9.06 2.4 8.205 2.04 7.3575C1.68 6.5025 1.5 5.685 1.5 4.905C1.5 4.395 1.59 3.9075 1.77 3.4575C1.95 3 2.235 2.58 2.6325 2.205C3.1125 1.7325 3.6375 1.5 4.1925 1.5C4.4025 1.5 4.6125 1.545 4.8 1.635C4.995 1.725 5.1675 1.86 5.3025 2.055L7.0425 4.5075C7.1775 4.695 7.275 4.8675 7.3425 5.0325C7.41 5.19 7.4475 5.3475 7.4475 5.49C7.4475 5.67 7.395 5.85 7.29 6.0225C7.1925 6.195 7.05 6.375 6.87 6.555L6.3 7.1475C6.2175 7.23 6.18 7.3275 6.18 7.4475C6.18 7.5075 6.1875 7.56 6.2025 7.62C6.225 7.68 6.2475 7.725 6.2625 7.77C6.3975 8.0175 6.63 8.34 6.96 8.73C7.2975 9.12 7.6575 9.5175 8.0475 9.915C8.4525 10.3125 8.8425 10.68 9.24 11.0175C9.63 11.3475 9.9525 11.5725 10.2075 11.7075C10.245 11.7225 10.29 11.745 10.3425 11.7675C10.4025 11.79 10.4625 11.7975 10.53 11.7975C10.6575 11.7975 10.755 11.7525 10.8375 11.67L11.4075 11.1075C11.595 10.92 11.775 10.7775 11.9475 10.6875C12.12 10.5825 12.2925 10.53 12.48 10.53C12.6225 10.53 12.7725 10.56 12.9375 10.6275C13.1025 10.695 13.275 10.7925 13.4625 10.92L15.945 12.6825C16.14 12.8175 16.275 12.975 16.3575 13.1625C16.4325 13.35 16.4775 13.5375 16.4775 13.7475Z" stroke="white" strokeWidth="1.125" strokeMiterlimit="10"/>
      <path d="M13.875 6.75C13.875 6.3 13.5225 5.61 12.9975 5.0475C12.5175 4.53 11.88 4.125 11.25 4.125" stroke="white" strokeWidth="1.125" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M16.5 6.75C16.5 3.8475 14.1525 1.5 11.25 1.5" stroke="white" strokeWidth="1.125" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  
  phoneMultiple: (
    <svg className='flex-none' width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M16.4775 13.7475C16.4775 14.0175 16.4175 14.295 16.29 14.565C16.1625 14.835 15.9975 15.09 15.78 15.33C15.4125 15.735 15.0075 16.0275 14.55 16.215C14.1 16.4025 13.6125 16.5 13.0875 16.5C12.3225 16.5 11.505 16.32 10.6425 15.9525C9.78 15.585 8.9175 15.09 8.0625 14.4675C7.2 13.8375 6.3825 13.14 5.6025 12.3675C4.83 11.5875 4.1325 10.77 3.51 9.915C2.895 9.06 2.4 8.205 2.04 7.3575C1.68 6.5025 1.5 5.685 1.5 4.905C1.5 4.395 1.59 3.9075 1.77 3.4575C1.95 3 2.235 2.58 2.6325 2.205C3.1125 1.7325 3.6375 1.5 4.1925 1.5C4.4025 1.5 4.6125 1.545 4.8 1.635C4.995 1.725 5.1675 1.86 5.3025 2.055L7.0425 4.5075C7.1775 4.695 7.275 4.8675 7.3425 5.0325C7.41 5.19 7.4475 5.3475 7.4475 5.49C7.4475 5.67 7.395 5.85 7.29 6.0225C7.1925 6.195 7.05 6.375 6.87 6.555L6.3 7.1475C6.2175 7.23 6.18 7.3275 6.18 7.4475C6.18 7.5075 6.1875 7.56 6.2025 7.62C6.225 7.68 6.2475 7.725 6.2625 7.77C6.3975 8.0175 6.63 8.34 6.96 8.73C7.2975 9.12 7.6575 9.5175 8.0475 9.915C8.4525 10.3125 8.8425 10.68 9.24 11.0175C9.63 11.3475 9.9525 11.5725 10.2075 11.7075C10.245 11.7225 10.29 11.745 10.3425 11.7675C10.4025 11.79 10.4625 11.7975 10.53 11.7975C10.6575 11.7975 10.755 11.7525 10.8375 11.67L11.4075 11.1075C11.595 10.92 11.775 10.7775 11.9475 10.6875C12.12 10.5825 12.2925 10.53 12.48 10.53C12.6225 10.53 12.7725 10.56 12.9375 10.6275C13.1025 10.695 13.275 10.7925 13.4625 10.92L15.945 12.6825C16.14 12.8175 16.275 12.975 16.3575 13.1625C16.4325 13.35 16.4775 13.5375 16.4775 13.7475Z" stroke="#009EE3" strokeWidth="1.125" strokeMiterlimit="10"/>
      <path d="M13.875 6.75C13.875 6.3 13.5225 5.61 12.9975 5.0475C12.5175 4.53 11.88 4.125 11.25 4.125" stroke="#009EE3" strokeWidth="1.125" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M16.5 6.75C16.5 3.8475 14.1525 1.5 11.25 1.5" stroke="#009EE3" strokeWidth="1.125" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  
  circlePhone: (
    <svg className='flex-none' width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="17.5" cy="17.5" r="17.5" fill="white"/>
      <path d="M20.869 17.618C20.7248 17.2532 20.6145 16.9137 20.5381 16.5998C20.4533 16.2773 20.3981 15.9846 20.3727 15.7216L13.1305 22.9637L12.4432 22.2764L19.6853 15.0343C19.4138 15.0003 19.1211 14.9452 18.8071 14.8688C18.4847 14.7839 18.1453 14.6736 17.7889 14.5379L18.3871 13.9397C19.5411 14.0245 20.5636 13.9184 21.4545 13.6215L21.7855 13.9524C21.48 14.8348 21.3739 15.8573 21.4673 17.0198L20.869 17.618Z" fill="black"/>
    </svg>
  )
};

// API Яндекс.Карт подключается один раз на страницу — тем же скриптом,
// что и карта в футере.
const YMAPS_SRC = 'https://api-maps.yandex.ru/2.1/?apikey=1b1f192d-9460-4afb-8ae3-c8fb7643c1ba&lang=ru_RU';
let ymapsPromise = null;

const loadYmaps = () => {
  if (typeof window === 'undefined') return Promise.reject(new Error('no window'));
  if (window.ymaps) return window.ymaps.ready ? new Promise((res) => window.ymaps.ready(() => res(window.ymaps))) : Promise.resolve(window.ymaps);
  if (!ymapsPromise) {
    ymapsPromise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = YMAPS_SRC;
      script.async = true;
      script.onload = () => window.ymaps.ready(() => resolve(window.ymaps));
      script.onerror = () => reject(new Error('ymaps load failed'));
      document.head.appendChild(script);
    });
  }
  return ymapsPromise;
};

// Точки из TV приходят строкой «lat, lng» через «;»
const parsePoints = (raw) => {
  if (!raw) return [];
  return (String(raw).match(/-?\d{1,3}\.\d{3,}\s*,\s*-?\d{1,3}\.\d{3,}/g) || []).map((pair) => {
    const [lat, lon] = pair.split(',').map((v) => parseFloat(v.trim()));
    return [lat, lon];
  });
};

// Карта через JS API — как в футере: не зависит от встраиваемого виджета,
// который на части сетей отдаёт ошибку протокола.
class YandexMap extends Component {
  state = { status: 'loading' };

  componentDidMount() {
    this.mounted = true;
    loadYmaps()
      .then(() => {
        if (!this.mounted || !this.container) return;
        this.initMap();
        this.setState({ status: 'ready' });
      })
      .catch(() => {
        if (this.mounted) this.setState({ status: 'failed' });
      });
  }

  componentWillUnmount() {
    this.mounted = false;
    if (this.map) {
      this.map.destroy();
      this.map = null;
    }
  }

  initMap() {
    const { points, zoom } = this.props;
    if (!points.length || !this.container) return;

    this.map = new window.ymaps.Map(this.container, {
      center: points[0],
      zoom: zoom || 16,
      controls: ['zoomControl']
    });

    points.forEach((coords, i) => {
      this.map.geoObjects.add(new window.ymaps.Placemark(
        coords,
        {
          hintContent: this.props.hints[i] || 'Наш адрес',
          balloonContent: this.props.balloons[i] || 'Наш адрес'
        },
        { preset: 'islands#blueDotIcon' }
      ));
    });

    if (points.length > 1) {
      this.map.setBounds(this.map.geoObjects.getBounds(), { checkZoomRange: true, zoomMargin: 40 });
    }
  }

  render() {
    const { height } = this.props;
    const { status } = this.state;

    if (status === 'failed') {
      return (
        <div
          className='w-full h-full rounded-[15px] bg-[#F5F7F9] flex items-center justify-center px-[20px] text-center'
          style={{ height }}
        >
          <div className='text-[#032432]/60 text-[14px] xl:text-[16px]'>Карта временно недоступна</div>
        </div>
      );
    }

    return (
      <div
        ref={(el) => { this.container = el; }}
        className='w-full h-full rounded-[15px] overflow-hidden bg-[#F5F7F9]'
        style={{ height }}
      >
        {status === 'loading' &&
          <div className='w-full h-full flex items-center justify-center'>
            <div className='text-[#032432]/60 text-[14px] xl:text-[16px]'>Загрузка карты...</div>
          </div>
        }
      </div>
    );
  }
}

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isClient: false
    };
  }

  componentDidMount() {
    this.setState({ isClient: true });
  }

  // Функция для форматирования телефонного номера в ссылку
  formatPhoneLink = (phone) => {
    if (!phone) return null;
    const cleanPhone = phone.replace(/[^\d]/g, '');
    return (
      <a href={`tel:${cleanPhone}`} className="hover:opacity-80 transition-opacity">
        {phone}
      </a>
    );
  }

  // Карта через JS API: координаты берём из page_vars (строка «lat, lng»),
  // при отсутствии — из резервного набора ниже.
  renderMap = (points, balloons, hints, height = '188px', zoom = 16) => {
    const { isClient } = this.state;

    if (!isClient || !points.length) {
      return (
        <div 
          className='w-full h-full rounded-[15px] bg-[#F5F7F9] flex items-center justify-center'
          style={{ height }}
        >
          <div className='text-[#032432]/60'>Загрузка карты...</div>
        </div>
      );
    }

    return (
      <YandexMap
        points={points}
        balloons={balloons}
        hints={hints}
        height={height}
        zoom={zoom}
      />
    );
  }

  render() {
    const data = this.props?.data || {};
    const page_vars = data?.page_vars || {};
    const page_vars_image = data?.page_vars_image || {};

    // Координаты из page_vars (p1coords/p2coords/p3coords), формат «lat, lng»;
    // несколько точек — через «;». Если в TV остался старый адрес виджета,
    // используем проверенные координаты по умолчанию.
    const fallbackPoints = {
      p1: [[56.157531, 40.386766]],
      p2: [[56.247753, 43.98339], [56.309982, 44.018286]],
      p3: [[55.801095, 37.594611]]
    };
    const pickPoints = (key) => {
      const parsed = parsePoints(page_vars?.[`${key}coords`]);
      return parsed.length ? parsed : fallbackPoints[key];
    };

    const vladimirPoints = pickPoints('p1');
    const nizhnyPoints = pickPoints('p2');
    const moscowPoints = pickPoints('p3');

    return (
      <div className='mt-[70px] xl:mt-[80px] tracking-[-0.04em] leading-none'>
        <div className='container'>
          {/* Верхний блок с контактами */}
          <div className='flex justify-center xl:justify-start items-center gap-[12px] text-[14px] xl:text-[16px] tracking-[-0.02em]'>
            <div className='inline-flex items-center px-[15px] h-[38px] bg-[#F5F7F9] rounded-full gap-[5px]'>
              {SVGIcons.package}
              <div className='tracking-[-0.04em] text-[#032432]/60'>Пункты продаж</div>
            </div>
          </div>
          
          {/* Верхний блок с контактами */}
          <div className='flex flex-col xl:flex-row items-center justify-between gap-[10px] mt-[17px]'>
            <div>
              <h2 className='font-medium text-[#032432] text-[24px] xl:text-[36px] text-center xl:text-start leading-none'>
                {Parser(page_vars?.title1 || 'Доступны в вашем регионе <span class="text-[#032432]/60">— официально, удобно, быстро</span>')}
              </h2>
              <div className='mt-[10px] text-[14px] xl:text-[16px] tracking-[-0.02em] text-center xl:text-start text-black/60'>
                {Parser(page_vars?.text1)}
              </div>
            </div>
            <div className='bg-[#F5F7F9] rounded-[15px] px-[20px] pt-[20px] flex flex-col xl:flex-row items-end justify-between gap-[12px] w-full xl:w-auto xl:max-w-[610px] mt-[15px] xl:mt-0'>
              <div className='pb-[20px]'>
                <div className='text-[#032432] text-[16px] xl:text-[18px]'>Как связаться с нами?</div>
                <div className='mt-[11px] text-[14px] xl:text-[16px] tracking-[-0.02em] text-[#032432]/60'>
                  {Parser(page_vars?.svaztext)}
                </div>
              </div>
              <div className='w-full xl:w-[258px] flex-none h-auto xl:h-[111px] p-[15px] bg-[#009EE3] rounded-t-[15px]'
                style={{
                  backgroundImage: `url("${page_vars_image?.card_bg}")`,
                  backgroundSize: 'cover'
                }}
              >
                <div className='flex items-center justify-between xl:justify-start gap-[8px]'>
                  <div>
                    <div className='text-[18px] text-white'>
                      <a href={`tel:88005006081`} className="hover:opacity-80 transition-opacity">
                        8 (800) 500-60-81
                      </a>
                    </div>
                    <div className='text-[14px] text-white/60'>Бесплатный звонок</div>
                  </div>
                  {SVGIcons.circlePhone}
                </div>
                <div className='grid grid-cols-2 gap-[10px] mt-[10px] text-[14px] text-white'>
                  <div>
                    {this.formatPhoneLink(page_vars?.ksp1)}<br />
                    {this.formatPhoneLink(page_vars?.ksp2)}
                  </div>
                  <div>
                    {this.formatPhoneLink(page_vars?.ksp3)}<br />
                    {this.formatPhoneLink(page_vars?.ksp4)}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Владимир с картой */}
          <div className='flex flex-col xl:flex-row items-center justify-between gap-[10px] mt-[40px]'>
            <div className='flex-1 w-full'>
              <h2 className='font-medium text-[#032432] text-[24px] xl:text-[36px] text-center xl:text-start leading-none'>
                {Parser(page_vars?.p1title || 'Представители <span class="text-[#032432]/60">в г. Владимир</span>')}
              </h2>
              <div className='flex flex-col xl:flex-row items-start gap-[10px] mt-[20px] w-full'>
                <div className='bg-[#F5F7F9] p-[20px] rounded-[15px] w-full xl:w-[310px]'>
                  <div className='text-[#032432] text-[18px]'>Продажа<br /><span className='text-[#032432]/60'>теплоносителей</span></div>
                  <div className='flex items-center gap-[7px] text-[14px] text-[#032432]/60 mt-[13px]'>
                    {SVGIcons.company}
                    <div>{page_vars?.p1name}</div>
                  </div>
                  <div className='flex items-center gap-[7px] text-[14px] text-[#032432]/60 mt-[6px]'>
                    {SVGIcons.location}
                    <div>{page_vars?.p1addr}</div>
                  </div>
                </div>
                <div className='bg-[#F5F7F9] p-[20px] rounded-[15px] flex-1 w-full xl:w-auto'>
                  <div className='text-[#032432] text-[18px]'>Телефоны <br /><span className='text-[#032432]/60'>для связи</span></div>
                  <div className='flex items-center gap-[7px] text-[14px] text-[#032432]/60 mt-[13px]'>
                    {SVGIcons.phone}
                    <div>{this.formatPhoneLink(page_vars?.p1phone1)}</div>
                  </div>
                  <div className='flex items-center gap-[7px] text-[14px] text-[#032432]/60 mt-[6px]'>
                    {SVGIcons.phone}
                    <div>{this.formatPhoneLink(page_vars?.p1phone2)}</div>
                  </div>
                </div>
              </div>
            </div>
            <div className='w-full xl:w-[646px] h-[188px] rounded-[15px] flex-none overflow-hidden'>
              {this.renderMap(
                vladimirPoints,
                [page_vars?.p1addr || 'г. Владимир, ул. Гастелло, д. 8, оф. 230'],
                ['ООО «Термотехника-Сервис»'],
                '188px',
                16
              )}
            </div>
          </div>

          {/* Нижний Новгород с картой */}
          <div className='flex flex-col xl:flex-row items-center justify-between gap-[10px] mt-[40px]'>
            <div className='flex-1 w-full'>
              <h2 className='font-medium text-[#032432] text-[24px] xl:text-[36px] text-center xl:text-start leading-none'>
                {Parser(page_vars?.p2title || 'Представители<br><span class="text-[#032432]/60">в г. Нижний Новгород</span>')}
              </h2>
              <div className='bg-[#F5F7F9] p-[20px] rounded-[15px] mt-[20px] w-full'>
                <div className='text-[#032432] text-[18px]'>Продажа<br /><span className='text-[#032432]/60'>теплоносителей</span></div>
                <div className='flex flex-col xl:flex-row items-start gap-[12px] mt-[15px]'>
                  <div>
                    <div className='flex items-start gap-[7px] text-[14px] text-[#032432]/60'>
                      {SVGIcons.company}
                      <div>{page_vars?.p2name}</div>
                    </div>
                    <div className='flex items-center gap-[7px] text-[14px] text-[#032432]/60 mt-[9px]'>
                      {SVGIcons.phoneMultiple}
                      <div>{this.formatPhoneLink(page_vars?.p2phone1)}</div>
                    </div>
                  </div>
                  <div>
                    <div className='flex items-start gap-[7px] text-[14px] text-[#032432]/60'>
                      {SVGIcons.company}
                      <div>{page_vars?.p2name2}</div>
                    </div>
                    <div className='flex items-center gap-[7px] text-[14px] text-[#032432]/60 mt-[9px]'>
                      {SVGIcons.phoneMultiple}
                      <div>{this.formatPhoneLink(page_vars?.p2phone2)}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className='w-full xl:w-[646px] h-[188px] xl:h-[241px] rounded-[15px] flex-none overflow-hidden'>
              {this.renderMap(
                nizhnyPoints,
                [page_vars?.p2name || 'Оптовый отдел фирмы «ЛАВА»', page_vars?.p2name2 || 'Розничный магазин фирмы «ЛАВА»'],
                ['Оптовый отдел', 'Розничный магазин'],
                '241px',
                12
              )}
            </div>
          </div>

          {/* Москва с картой */}
          <div className='flex flex-col xl:flex-row items-center justify-between gap-[10px] mt-[40px]'>
            <div className='flex-1 w-full'>
              <h2 className='font-medium text-[#032432] text-[24px] xl:text-[36px] text-center xl:text-start leading-none'>
                {Parser(page_vars?.p3title || 'Представители <span class="text-[#032432]/60">в г. Москва</span>')}
              </h2>
              <div className='flex flex-col xl:flex-row items-start gap-[10px] mt-[20px] w-full'>
                <div className='bg-[#F5F7F9] p-[20px] rounded-[15px] w-full xl:w-[310px]'>
                  <div className='text-[#032432] text-[18px]'>Продажа<br /><span className='text-[#032432]/60'>теплоносителей</span></div>
                  <div className='flex items-start gap-[7px] text-[14px] text-[#032432]/60 mt-[15px]'>
                    {SVGIcons.location}
                    <div>{page_vars?.p3addr}</div>
                  </div>
                </div>
                <div className='bg-[#F5F7F9] p-[20px] rounded-[15px] flex-1 w-full xl:w-auto'>
                  <div className='text-[#032432] text-[18px]'>Телефоны <br /><span className='text-[#032432]/60'>для связи</span></div>
                  <div className='flex items-center gap-[7px] text-[14px] text-[#032432]/60 mt-[25px]'>
                    {SVGIcons.phoneMultiple}
                    <div>{this.formatPhoneLink(page_vars?.p3phone)}</div>
                  </div>
                </div>
              </div>
            </div>
            <div className='w-full xl:w-[646px] h-[188px] rounded-[15px] flex-none overflow-hidden'>
              {this.renderMap(
                moscowPoints,
                [page_vars?.p3addr || '127018, г. Москва, ул. Складочная, д. 1, стр. 1'],
                ['ПКФ ХимАвангард'],
                '188px',
                16
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default App;